/**
 * @param row A table row.
 * @param categoryString A category string.
 * @returns `true` if the given table row's category matches the given category string.
 */
const doesRowMatchCategoryString = (row, categoryString) => {
  return Object.keys(row).some(
    (key) => row.itemClass.indexOf(categoryString) !== -1 || row.itemPriceClass.indexOf(categoryString) !== -1
  );

}

export default doesRowMatchCategoryString;
